import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, } from "react";
import block from "bem-cn-lite";
import { Button, Checkbox, Icon, List, Switch, Text, TextInput, Tooltip, } from "@gravity-ui/uikit";
import { useDebounce } from "use-debounce";
import { Magnifier } from "@gravity-ui/icons";
import "./SharedSearchBar.scss";
const b = block("search-bar");
export const SharedSearchBar = (props) => {
    const { onSearchClick, onInputChange, onBrandSelected, onUseAnalogsChanged, onBrandSuggestionsChanged, onSearchHistorySelected, searchText, useAnalogs, searchBrand, size, mode, disabledTextInput, searchHistory, searchType, showAsyncSwitch, basketItemCount = 0, totalAmount = 0, renderBasketButton, fetchBrandSuggestions, } = props;
    const isInit = useRef(true);
    const searchTextRef = useRef(searchText);
    const listRef = useRef(null);
    const listContainerRef = useRef(null);
    const [searchInputFocus, setSearchInputFocus] = useState(false);
    const [suggestItems, setSuggestItems] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(true);
    const [showSearchHistory, setShowSearchHistory] = useState(false);
    const [debouncedSearchInputValue] = useDebounce(searchText, 300);
    const [debouncedSearchInputFocus] = useDebounce(searchInputFocus, 100);
    const [isInItem, setIsInItem] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    function cleanSearchValue(value) {
        if (!value)
            return "";
        return value
            .replace(/[^a-zA-Z0-9аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ]+/g, "")
            .toUpperCase();
    }
    // Ввод текста
    function onSearchInputChangeHandler(event) {
        isInit.current = false;
        if (onInputChange) {
            const cleanedValue = cleanSearchValue(event.target.value);
            searchTextRef.current = {
                originalValue: event.target.value,
                cleanedValue,
                needToSuggestBrands: true,
            };
            onInputChange(searchTextRef.current);
        }
    }
    // Аналоги
    function onUseAnalogsChangedHandler(value) {
        onUseAnalogsChanged?.(value);
    }
    // Фокус на инпуте
    const handleInputFocus = () => {
        setSearchInputFocus(true);
        const shouldShowSuggestions = searchText.originalValue.length > 0 && suggestItems.length > 0;
        const shouldShowSearchHistory = searchText.originalValue.length === 0 && searchHistory.length > 0;
        setShowSuggestions(shouldShowSuggestions);
        setShowSearchHistory(!shouldShowSuggestions && shouldShowSearchHistory);
    };
    // Потеря фокуса
    const handleInputBlur = (event) => {
        const target = event.relatedTarget;
        if (target && listContainerRef.current?.contains(target)) {
            return;
        }
        setSearchInputFocus(false);
        setShowSuggestions(false);
        setShowSearchHistory(false);
    };
    // Выбор бренда
    function handleBrandSelected(brand) {
        setShowSuggestions(false);
        setShowSearchHistory(false);
        setSearchInputFocus(false);
        onBrandSelected?.(brand);
    }
    // Выбор из истории
    function handleSearchHistorySelected(historyItem) {
        setShowSuggestions(false);
        setShowSearchHistory(false);
        setSearchInputFocus(false);
        isInit.current = true;
        onSearchHistorySelected?.(historyItem);
    }
    // Клик «Искать»
    function handleSearchClick() {
        if (listRef.current !== null) {
            const currentIndex = listRef.current.getActiveItem();
            if (currentIndex !== null && currentIndex >= 0) {
                const brand = listRef.current.getItems()[currentIndex];
                if (brand) {
                    handleBrandSelected(brand);
                    return;
                }
            }
        }
        setShowSuggestions(false);
        setShowSearchHistory(false);
        setSuggestItems([]);
        onSearchClick?.();
    }
    // Навигация по списку
    function handleKeyDown(event) {
        if (showSuggestions && suggestItems.length > 0) {
            if (event.key === "ArrowDown") {
                event.preventDefault();
                setSelectedIndex((prevIndex) => (prevIndex + 1) % suggestItems.length);
            }
            else if (event.key === "ArrowUp") {
                event.preventDefault();
                setSelectedIndex((prevIndex) => (prevIndex - 1 + suggestItems.length) %
                    suggestItems.length);
            }
            else if (event.key === "Enter") {
                event.preventDefault();
                if (selectedIndex >= 0 && selectedIndex < suggestItems.length) {
                    const selectedItem = suggestItems[selectedIndex];
                    handleBrandSelected(selectedItem);
                }
                else {
                    handleSearchClick();
                }
            }
        }
        else if (showSearchHistory && searchHistory.length > 0) {
            if (event.key === "ArrowDown") {
                event.preventDefault();
                setSelectedIndex((prevIndex) => (prevIndex + 1) % searchHistory.length);
            }
            else if (event.key === "ArrowUp") {
                event.preventDefault();
                setSelectedIndex((prevIndex) => (prevIndex - 1 + searchHistory.length) %
                    searchHistory.length);
            }
            else if (event.key === "Enter") {
                event.preventDefault();
                if (selectedIndex >= 0 &&
                    selectedIndex < searchHistory.length) {
                    const selectedItem = searchHistory[selectedIndex];
                    handleSearchHistorySelected(selectedItem);
                }
                else {
                    handleSearchClick();
                }
            }
        }
        else if (event.key === "Enter") {
            event.preventDefault();
            handleSearchClick();
        }
    }
    // Наведение на элемент списка
    function handleSuggestionItemMouseEnter() {
        setIsInItem(true);
    }
    function handleSuggestionItemMouseLeave() {
        setIsInItem(false);
    }
    // useEffect для получения подсказок
    useEffect(() => {
        let ignore = false;
        if (isInit.current) {
            return () => {
                ignore = true;
            };
        }
        // Если нет значения — чистим подсказки
        if (!debouncedSearchInputValue?.cleanedValue) {
            setSuggestItems([]);
            setShowSuggestions(false);
            setShowSearchHistory(searchHistory.length > 0);
            onBrandSuggestionsChanged?.([]);
            return () => {
                ignore = true;
            };
        }
        // Если указано, что подсказки не нужны
        if (!debouncedSearchInputValue.needToSuggestBrands) {
            return () => {
                ignore = true;
            };
        }
        // Если нет коллбека для запроса — выходим
        if (!fetchBrandSuggestions) {
            return () => {
                ignore = true;
            };
        }
        const result = fetchBrandSuggestions(debouncedSearchInputValue.cleanedValue);
        // Если вернулся Promise
        if (result instanceof Promise) {
            result
                .then((items) => {
                if (ignore)
                    return;
                if (searchTextRef.current.cleanedValue ===
                    debouncedSearchInputValue.cleanedValue) {
                    setSuggestItems(items);
                    setShowSuggestions(items.length > 0);
                    setShowSearchHistory(false);
                    onBrandSuggestionsChanged?.(items);
                }
            })
                .catch((err) => {
                // eslint-disable-next-line no-console
                console.log(err);
            });
        }
        else {
            // Синхронный ответ
            if (searchTextRef.current.cleanedValue ===
                debouncedSearchInputValue.cleanedValue) {
                setSuggestItems(result);
                setShowSuggestions(result.length > 0);
                setShowSearchHistory(false);
                onBrandSuggestionsChanged?.(result);
            }
        }
        return () => {
            ignore = true;
        };
    }, [debouncedSearchInputValue]);
    // Управляем видимостью подсказок по фокусу
    useEffect(() => {
        if (!searchInputFocus)
            return;
        const shouldShowSuggestions = searchInputFocus &&
            searchText.originalValue.length > 0 &&
            suggestItems.length > 0;
        setShowSuggestions(shouldShowSuggestions);
        const shouldShowSearchHistory = searchInputFocus &&
            searchText.originalValue.length === 0 &&
            searchHistory.length > 0;
        setShowSearchHistory(!shouldShowSuggestions && shouldShowSearchHistory);
    }, [
        searchInputFocus,
        searchText.originalValue,
        searchHistory,
        suggestItems.length,
    ]);
    // Если пропал фокус и мы не в элементе списка — скрываем
    useEffect(() => {
        if (debouncedSearchInputFocus || isInItem)
            return;
        setShowSuggestions(false);
        setShowSearchHistory(false);
    }, [debouncedSearchInputFocus, isInItem]);
    // Клик вне дропдауна — скрываем списки
    useEffect(() => {
        const handleClickOutside = (event) => {
            const target = event.target;
            if (target &&
                listContainerRef.current &&
                !listContainerRef.current.contains(target) &&
                !target.closest("input")) {
                setShowSuggestions(false);
                setShowSearchHistory(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const placeholder = mode === "admin"
        ? "Артикул, бренд"
        : size === "s"
            ? "Поиск по артикулу"
            : "Поиск по артикулу, VIN";
    return (_jsxs("div", { className: b("search-container"), children: [_jsx("div", { className: b() + " " + size, children: _jsxs("div", { className: b("search-fields"), children: [_jsxs("div", { className: b("search-input-group"), children: [_jsx("div", { className: b("search-input-group-container"), children: _jsx(TextInput, { size: "xl", view: "normal", placeholder: placeholder, className: mode === "admin" ? b("admin-input") : b("search-input"), value: searchText.originalValue, onChange: onSearchInputChangeHandler, onFocus: handleInputFocus, onBlur: handleInputBlur, onKeyDown: (e) => handleKeyDown(e), disabled: mode === "admin" && disabledTextInput, leftContent: _jsx(_Fragment, { children: mode === "admin" && (_jsx("div", { className: b("search-button"), children: _jsx(Icon, { data: Magnifier, width: "16", height: "16", className: b("search-icon") }) })) }), rightContent: _jsx(_Fragment, { children: mode !== "admin" && (_jsxs(_Fragment, { children: [_jsx(Checkbox, { size: "l", checked: useAnalogs, onChange: (x) => onUseAnalogsChangedHandler(x.target.checked), children: "\u0410\u043D\u0430\u043B\u043E\u0433\u0438" }), size === "s" && (_jsx(Button, { size: "l", className: b("search-button"), onClick: handleSearchClick, children: _jsx(Icon, { data: Magnifier, width: "16", height: "16", className: b("search-icon") }) }))] })) }) }) }), showSuggestions ? (_jsx("div", { ref: listContainerRef, children: _jsx(List, { items: suggestItems, className: b("search-suggestions"), itemHeight: 50, filterable: true, itemsHeight: () => {
                                            const heigthItems = 50 * suggestItems.length + 4;
                                            const heightScreen = window.innerHeight - 388;
                                            return heigthItems < heightScreen
                                                ? heigthItems
                                                : heightScreen;
                                        }, onItemClick: handleBrandSelected, renderItem: (item) => {
                                            return (_jsxs("div", { onMouseEnter: handleSuggestionItemMouseEnter, onMouseLeave: handleSuggestionItemMouseLeave, className: b("search-suggestions-inner-item"), children: [_jsx("div", { className: b("search-suggestions-brand"), children: _jsx(Text, { variant: "body-1", children: searchText.originalValue +
                                                                " (" +
                                                                item.name +
                                                                ")" }) }), _jsx(Text, { variant: "body-1", color: "secondary", children: item.articleName })] }));
                                        }, itemsClassName: b("search-suggestions-items"), itemClassName: b("search-suggestions-item"), filterClassName: b("search-suggestions-filter"), filterPlaceholder: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438:", activeItemIndex: selectedIndex }) })) : (_jsx(_Fragment, {})), showSearchHistory ? (_jsx("div", { ref: listContainerRef, children: _jsx(List, { items: searchHistory, className: b("search-suggestions"), itemHeight: 50, filterable: true, itemsHeight: () => {
                                            const heigthItems = 50 * searchHistory.length + 4;
                                            const heightScreen = window.innerHeight - 388;
                                            return heigthItems < heightScreen
                                                ? heigthItems
                                                : heightScreen;
                                        }, onItemClick: handleSearchHistorySelected, renderItem: (item) => {
                                            return (_jsxs("div", { onMouseEnter: handleSuggestionItemMouseEnter, onMouseLeave: handleSuggestionItemMouseLeave, className: b("search-suggestions-inner-item"), children: [_jsx("div", { className: b("search-suggestions-brand"), children: _jsx(Text, { variant: "body-1", children: item.article +
                                                                " (" +
                                                                item.brand +
                                                                ")" }) }), _jsx(Text, { variant: "body-1", color: "secondary", children: item.articleName })] }));
                                        }, itemsClassName: b("search-suggestions-items"), itemClassName: b("search-suggestions-item"), filterClassName: b("search-suggestions-filter"), filterPlaceholder: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u044B:", activeItemIndex: selectedIndex }) })) : (_jsx(_Fragment, {}))] }), size !== "s" && (_jsxs(_Fragment, { children: [_jsx(Button, { size: "xl", view: "action", onClick: handleSearchClick, children: "\u0418\u0441\u043A\u0430\u0442\u044C" }), renderBasketButton?.() ?? null] }))] }) }), mode === "admin" && (_jsxs("div", { className: b("admin-buttons"), children: [_jsx(Checkbox, { size: "l", checked: useAnalogs, onChange: (x) => onUseAnalogsChangedHandler(x.target.checked), children: "\u0410\u043D\u0430\u043B\u043E\u0433\u0438" }), showAsyncSwitch && (_jsx(Tooltip, { content: _jsxs(Text, { variant: "body-1", className: b("tooltip-content"), children: ["\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C", _jsx("br", {}), " \u043D\u0430 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u044B\u0439 \u043F\u043E\u0438\u0441\u043A"] }), contentClassName: b("tooltip"), className: b("tooltip-container"), placement: "bottom-start", openDelay: 0, closeDelay: 0, children: _jsxs("div", { className: b("switch-async-search"), children: [_jsx(Switch, { size: "m", checked: true, onUpdate: () => { } }), _jsx(Text, { variant: "body-2", children: "\u0410\u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u044B\u0439" })] }) })), _jsx(Button, { size: "xl", view: "action", disabled: false, onClick: handleSearchClick, children: "\u0418\u0441\u043A\u0430\u0442\u044C" })] }))] }));
};
